import React from 'react';
import { useT } from '../../i18n/LocaleContext';
import { formatRelativeTime } from '../../utils/format';

const DOT_COLORS = {
  green: 'var(--success)',
  gold: 'var(--gold)',
  blue: 'var(--blue-light)',
  red: 'var(--red-accent)',
};

export default function ActivityFeed({ items }) {
  const t = useT();

  if (!items || items.length === 0) {
    return <div className="empty-state__body" style={{ padding: '8px 0' }}>{t('common.no_data')}</div>;
  }

  return (
    <div>
      {items.map((item) => (
        <div key={item.id} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '10px 0', borderBottom: '1px solid rgba(226,221,212,0.5)' }}>
          <div style={{
            width: '7px', height: '7px',
            borderRadius: '50%',
            marginTop: '6px',
            flexShrink: 0,
            background: DOT_COLORS[item.dot] || 'var(--gold)',
          }} />
          <div>
            <div style={{ fontSize: '13.5px', color: 'var(--text)', lineHeight: '1.45' }}>
              {item.textKey ? t(item.textKey, item.params) : (item.description || item.action || '')}
            </div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '1px', fontStyle: 'italic' }}>
              {formatRelativeTime(item.at, t)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
